import classNames from 'classnames';
import React from 'react';

import hexToRgba from '../../../../helpers/color/hexToRgba';
import styles from '../../HorizontalSlider.module.css';
import FadeConfiguration from '../../types/FadeConfiguration';

export const defaultFadeWidth = 15;

type FadesProps = FadeConfiguration & {
    hideLeft?: boolean;
    hideRight?: boolean;
};

const Fades = ({
    width = defaultFadeWidth,
    offsetY = 0,
    placement = 'none',
    color = '#ffffff',
    hideRight,
    hideLeft,
}: FadesProps) => {
    return (
        <>
            {(placement === 'both' || placement === 'left') && (
                <span
                    className={classNames(styles.Fade, styles.Fade_left)}
                    style={{
                        opacity: hideLeft ? 0 : 1,
                        width: width,
                        top: offsetY,
                        background: `linear-gradient(to right, ${color}, ${hexToRgba(
                            color,
                            0
                        )})`,
                    }}
                />
            )}

            {(placement === 'both' || placement === 'right') && (
                <span
                    className={classNames(styles.Fade, styles.Fade_right)}
                    style={{
                        opacity: hideRight ? 0 : 1,
                        width: width,
                        top: offsetY,
                        background: `linear-gradient(to left, ${color}, ${hexToRgba(
                            color,
                            0
                        )})`,
                    }}
                />
            )}
        </>
    );
};

export default Fades;
